export default "__VITE_ASSET__DXYVhZiU__"